import http from '@/services/http'
import { sleep } from '@/utils'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    organizations: [],
    saveInProgress: false,
    isRemoveInProgress: false,
    totalCount: null,
  },
  mutations: {
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    SET_ORGANIZATION_LIST_DATA(state, { organizations, totalCount }) {
      state.organizations = organizations
      state.totalCount = totalCount
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },

    START_REMOVE(state) {
      state.removeInProgress = true
    },
    STOP_REMOVE(state) {
      state.removeInProgress = false
    },
    REMOVE_ORGANIZATION(state, id) {
      state.organizations = state.organizations.filter((o) => o.id !== id)
    },
  },
  actions: {
    async fetch({ commit }, params = {}) {
      params.page_size = params.page_size || 1000
      commit('START_FETCH')
      const response = await http.getAuthed('/organizations', params)
      commit('SET_ORGANIZATION_LIST_DATA', {
        organizations: response.data.results,
        totalCount: response.data.count,
      })
      commit('STOP_FETCH')
    },
    async create({ commit }, { name }) {
      commit('START_SAVE')
      const response = http.postAuthed('/organizations/create', { name: name })
      sleep(1000)
      await response
      commit('STOP_SAVE')
    },
    async remove({ commit }, { id }) {
      commit('START_REMOVE')
      const response = http.postAuthed(`/organizations/${id}/remove`)
      sleep(1000)
      try {
        await response
      } finally {
        commit('STOP_REMOVE')
      }
      commit('REMOVE_ORGANIZATION', id)
    },
  },
}
